"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminSizeComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//INTERNAL BITS
const admin_service_1 = require("./admin.service");
const permission_service_1 = require("./permission.service");
const notification_service_1 = require("./notification.service");
const size_service_1 = require("./size.service");
let AdminSizeComponent = class AdminSizeComponent {
    constructor(_talk, _admin, _cd, _size, _permission) {
        this._talk = _talk;
        this._admin = _admin;
        this._cd = _cd;
        this._size = _size;
        this._permission = _permission;
        this.sizeModel = { width: '', height: '' };
    }
    ngOnInit() {
        this.permission = this._permission.get();
        this.sizes = this._size.get();
    }
    createSize(size) {
        let numCheck = new RegExp('[^0-9]', "g");
        let displayNameCheck = size.width + "x" + size.height;
        if (numCheck.test(size.height) || numCheck.test(size.width)) {
            return this._talk.broadcast("Height and Width must both be entered as numbers.");
        }
        if (this.sizes.filter(r => { return r.displayName == displayNameCheck; }).length > 0) {
            return this._talk.broadcast("The size you are attempting to add already exists.");
        }
        if (size.width > 10000 || size.height > 10000) {
            return this._talk.broadcast("The size you are attempting to add are too big.");
        }
        Promise.resolve(this._admin.createSize(size)).then(err => {
            Promise.resolve(this._size.pull()).then(err => {
                this.sizes = this._size.get();
                this.sizeModel = { width: '', height: '' };
                this._cd.markForCheck();
            }).catch(err);
        }).catch(err => { return this._talk.broadcast("There was an issue saving your size.  Please contact your administrator."); });
    }
};
exports.AdminSizeComponent = AdminSizeComponent;
exports.AdminSizeComponent = AdminSizeComponent = __decorate([
    (0, core_1.Component)({
        selector: 'admin-size',
        templateUrl: 'app/admin-size.component.html',
        styleUrls: ['styles/admin.component.css'],
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [notification_service_1.NotificationService,
        admin_service_1.AdminService,
        core_1.ChangeDetectorRef,
        size_service_1.SizeService,
        permission_service_1.PermissionService])
], AdminSizeComponent);
//# sourceMappingURL=admin-size.component.js.map